import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../../utils/rel';

class TabSwitch extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        other: PropTypes.object,
    };

    tabTimer = null;

    componentDidMount() {
        this.tabTimer = setInterval(() => {
            this.loop();
        }, 5000);
    }

    loop = () => {
        const { tabChange, type, showArrow, len } = this.props.other;
        let newType = type;

        // 鼠标进入直接return;
        if (showArrow) return;

        if (type + 1 >= len) {
            newType = 0;
        } else if (type < 0) {
            newType = len - 1;
        } else {
            newType += 1;
        }
        tabChange(newType);
    };

    hoverLi = e => {
        e.stopPropagation();

        const { other } = this.props;
        const { type: newType, tabChange } = other;

        const type = e.currentTarget.getAttribute('data-type');

        if (type === null && type === newType) return;
        tabChange(type);
    };
    componentWillUnmount() {
        this.tabTimer = null;
    }

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content, other } = this.props;
        const { type } = other;

        const listDom = content.map((item, index) => (
            <li
                key={index}
                data-type={index}
                onMouseEnter={this.hoverLi}
                className={type === index ? styles.current : ''}>
                <a href={item.url} target="_blank" rel={rel}>
                    {item.title}
                </a>
            </li>
        ));

        return <ul className={styles.wrap}>{listDom}</ul>;
    }
}

export default errorBoundary(TabSwitch);
